import React, { Component } from 'react';
import FormicaInput from '../FormicaInput';
import { OverlayPanel } from 'primereact/overlaypanel';
import { HexColorPicker } from 'react-colorful';

class FormicaColorPicker extends Component<Props, State> {
  public state = new State();
  private overlayPanelRef: OverlayPanel | null = null;

  render() {
    const { value, onChange } = this.props;
    return (
      <div className={'flex flex-col w-full h-full py-5]'}>
        <div className={'flex items-center w-full relative'} onClick={(e) => this.overlayPanelRef?.toggle(e)}>
          <div
            style={{ backgroundColor: value }}
            className={`absolute top-1/2 transform -translate-x-1/2 z-50 -translate-y-1/2 left-4 w-4 h-4 rounded-[2px]`}
          ></div>
          <FormicaInput className={'indent-8'} value={value.toUpperCase()} inputSize={'md'} onChange={(e) => {}} />
        </div>
        <OverlayPanel
          ref={(el) => (this.overlayPanelRef = el)}
          className={'flex flex-col items-center gap-y-3 bg-white shadow-md  px-5 py-5 justify-center w-auto'}
          dismissable={true}
        >
          <div className={'flex items-center w-full'}>
            <HexColorPicker color={value} onChange={(e) => onChange(e)} />
          </div>
          <div className={'flex flex-col w-full gap-y-3 py-2'}>
            <p className={'text-f-black-2 text-sm '}>Suggestion Colors</p>
            <div className={'grid grid-cols-10 gap-y-2 '}>
              {this.state.colors.map((color, index) => {
                return (
                  <div
                    key={index}
                    onClick={(e) => this.onClickSuggestionColors(color)}
                    style={{ backgroundColor: color }}
                    className={'h-4 w-4 rounded-[4px] cols-span-1'}
                  ></div>
                );
              })}
            </div>
          </div>
        </OverlayPanel>
      </div>
    );
  }

  private onClickSuggestionColors = (e: string): void => {
    const { onChange } = this.props;
    onChange(e);
  };
}

interface Props {
  onChange: (color: string) => void;
  value: string;
}

class State {
  colors: string[] = ['#84C9B3', '#84A8D5', '#C56565', '#A488CB', '#DBA9C7', '#EDD981', '#CDC1A2', '#E9A669', '#B98171', '#EE8769'];
}

export default FormicaColorPicker;
